import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import SummaryBundleOptionValue from "./SummaryBundleOptionValue";
const SummaryBundleOption = ({ categoryName, values }) => (_jsx(_Fragment, { children: values.map((option) => {
        const { initial_price, presentation_price, product } = option?.presentation_info || {};
        let product_name = "label" in option ? option.label : option.product_name;
        if (values.length > 1) {
            product_name = `${categoryName}: ${product_name}`;
        }
        return (_jsx(SummaryBundleOptionValue, { prices: { initial_price, presentation_price }, quantity: option.quantity, imageUrl: product?.small_image?.url, product_name: product_name, tooltip_info: option?.presentation_info.product.tooltip_info }, `${categoryName} - ${option.id}`));
    }) }));
export default SummaryBundleOption;
//# sourceMappingURL=SummaryBundleOption.js.map